import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'badge', 'IconBadge', [["path",{"d":"M17 17v-13l-5 3l-5 -3v13l5 3z","key":"svg-0"}]]);